import { Statsig, useGateWithExposureLoggingDisabled } from 'statsig-react';
import { useWarnAboutMissingStatsigProvider } from '~/common/Statsig/useWarnAboutMissingStatsigProvider';

export function useIsGateEnabled({
    gateName,
    defaultValue = false,
    enableExposure = true
}: {
    gateName: string;
    defaultValue?: boolean;
    enableExposure?: boolean;
}) {
    useWarnAboutMissingStatsigProvider({ gateName });

    // See comment in useMXExperimentConfigValue.ts
    //const gate = useGate(gateName);
    const gateWithExposureLoggingDisabled =
        useGateWithExposureLoggingDisabled(gateName);

    if (enableExposure) {
        Statsig.manuallyLogGateExposure(gateName);
    }

    return gateWithExposureLoggingDisabled.value ?? defaultValue;
}
